/**
 * A Markdown file, rendered as the document it is.
 *
 * The app's one Markdown renderer, with its chat plugins switched off: a `@name` in a README is
 * an email address or a package scope, a `:shrug:` is punctuation, and a bare path is not a route
 * into this app. Those three features exist so a *message* someone wrote in this app resolves
 * against it; a file someone uploaded was not written against it at all.
 */

import { MessageMarkdown } from "@/components/ui/message-markdown";
import { PREVIEW_READING_COLUMN_CLASS } from "./reading-column";

export function MarkdownPreviewBody({ text }: { text: string }) {
  return (
    <div className={PREVIEW_READING_COLUMN_CLASS} data-testid="document-preview-markdown">
      <MessageMarkdown
        content={text}
        features={{ mentions: false, emojiReplacement: false, internalLinkResolution: false }}
      />
    </div>
  );
}
